<template>
<v-container>
</v-container>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "SignupVerifyEmail",
  computed: mapState(["continueHref"]),
  created() {
    this.$axios.get(`signup/finish?id=${this.$route.query.id}&continue=${this.continueHref}`)
      .then(() => {
        this.$store.dispatch("addNotification", {
          type: 'success',
          message: 'Hooray! your email was successfully verified, Please feel free to login.'
        });
        if (this.continueHref) {
          this.$router.push({ name: 'login', query : { continue: this.continueHref} })
        } else {
          this.$router.push({ name: 'login' })
        }
      })
      .catch((error) => {
        console.error(error)
        this.$store.dispatch("addNotification", {
          type: 'warning',
          message: 'Oops something not quite right, We are unable to verify your email. Please contact support'
        });
        this.$router.push({ name: 'login' })
      })
  }
}
</script>